import React from "react";
import { Container } from "@mantine/core";
import { Routes, Route } from "react-router-dom";
import DataMigrationHub from "../../components/dataMigration/DataMigrationHub";
import InspalMigrationWizard from "../../components/dataMigration/InspalMigrationWizard";
import CustomDataMigrationWizard from "../../components/dataMigration/CustomDataMigrationWizard";

const DataMigration = () => {
  return (
    <Container size="xl" py="md">
      <Routes>
        <Route index element={<DataMigrationHub />} />
        <Route path="inspal" element={<InspalMigrationWizard />} />
        <Route path="custom" element={<CustomDataMigrationWizard />} />
      </Routes>
    </Container>
  );
};

export default DataMigration;
